import React from "react";
import { ClientRowData } from "../types";

interface RemoveConfirmationModalProps {
    showRemove: boolean;
    setShowRemove: (show: boolean) => void;
    removeTarget: ClientRowData | null;
    cycleYear: number;
    removeComment: string;
    setRemoveComment: (v: string) => void;
    handleConfirmRemove: () => void;
    isSubmitting: boolean;
}

export const RemoveConfirmationModal: React.FC<RemoveConfirmationModalProps> = ({
    showRemove,
    setShowRemove,
    removeTarget,
    cycleYear,
    removeComment,
    setRemoveComment,
    handleConfirmRemove,
    isSubmitting,
}) => {
    if (!showRemove || !removeTarget) return null;

    return (
        <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 50 }}>
            <div style={{ background: "#fff", borderRadius: "14px", width: "440px", maxWidth: "90vw", padding: "26px" }}>
                <div style={{ display: "flex", alignItems: "flex-start", gap: "14px" }}>
                    <div style={{ width: "42px", height: "42px", borderRadius: "10px", background: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                            <line x1="12" y1="9" x2="12" y2="13"></line>
                            <line x1="12" y1="17" x2="12.01" y2="17"></line>
                        </svg>
                    </div>
                    <div>
                        <div style={{ fontSize: "16px", fontWeight: 700, color: "#1e293b" }}>
                            Remover reajuste do ciclo {cycleYear}?
                        </div>
                        <div style={{ fontSize: "13.5px", color: "#64748b", marginTop: "6px", lineHeight: 1.5 }}>
                            O cliente <strong>{removeTarget.clientFantasyName}</strong> voltará ao valor de fallback para este ciclo. A ação fica registrada no histórico.
                        </div>
                    </div>
                </div>

                <div style={{ marginTop: "16px" }}>
                    <label style={{ fontSize: "12px", fontWeight: 600, color: "#475569", display: "block", marginBottom: "6px" }}>
                        Justificativa (obrigatório) *
                    </label>
                    <textarea
                        placeholder="Descreva o motivo da remoção..."
                        value={removeComment}
                        onChange={(e) => setRemoveComment(e.target.value)}
                        style={{ width: "100%", padding: "9px 10px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "13px", fontFamily: "inherit", resize: "vertical", minHeight: "70px", outline: "none" }}
                    />
                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "22px" }}>
                    <button
                        onClick={() => setShowRemove(false)}
                        disabled={isSubmitting}
                        style={{ background: "#fff", color: "#334155", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "10px 16px", fontSize: "13.5px", fontWeight: 600, cursor: "pointer" }}
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleConfirmRemove}
                        disabled={isSubmitting || !removeComment.trim()}
                        style={{
                            background: removeComment.trim() ? "#dc2626" : "#cbd5e1",
                            color: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            padding: "10px 16px",
                            fontSize: "13.5px",
                            fontWeight: 600,
                            cursor: removeComment.trim() ? "pointer" : "not-allowed",
                        }}
                    >
                        {isSubmitting ? "Removendo..." : "Remover"}
                    </button>
                </div>
            </div>
        </div>
    );
};
